import { Component, OnInit, OnDestroy } from '@angular/core';

import {
  AdjustmentType,
  AdjustmentTypeErrorResponse,
  AdjustmentTypeModalPayload,
  TbaParameter,
  Message,
} from '../../../shared/models';

import { AdjustmentTypesService, TbasService, SessionService, NotificationService } from '../../../shared/services';

import { ModalService, ConfirmationModalComponent } from '../../../shared/modules/modal';
import {
  ClosableModalWithErrorResponseModel
} from '../../../shared/components/base/closable-modal-with-error-response-model';
import { TinyTextEditor } from '../../../shared/constants';

@Component({
  selector: 'add-adjustment-type-modal',
  templateUrl: './add-adjustment-type-modal.component.html',
})
export class AddAdjustmentTypeModalComponent
  extends ClosableModalWithErrorResponseModel<AdjustmentTypeErrorResponse>
  implements OnInit, OnDestroy {
  adjustmentType: AdjustmentType;
  parameters: TbaParameter[];
  data: AdjustmentTypeModalPayload;

  tinyInit = TinyTextEditor.INIT;

  constructor(protected modalService: ModalService,
    protected notificationService: NotificationService,
    private _adjustmentTypesService: AdjustmentTypesService,
    private _tbasService: TbasService,
    private _sessionService: SessionService
  ) {
    super(notificationService, modalService);
    this.validationErrors = new AdjustmentTypeErrorResponse();
  }

  ngOnInit(): void {
    this.adjustmentType = new AdjustmentType();
    this.adjustmentType.container = this._sessionService.getWorkingContainer();
    this.adjustmentType.tba.tbaId = this.data.tbaId;
    this.getAllowedParams();
    if (this.data.adjustmentTypeId) {
      this.getAdjustmentType();
    }
    this.listenForErrorMessages();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  save(): void {
    if (this.isSaveDisabled) {
      return;
    }

    this.isSaveDisabled = true;

    this.responseErrors = [];
    if (!this.data.adjustmentTypeId) {
      this.create();
      return;
    }
    this.edit();
  }

  close(form = null): void {
    if (form && form.form.touched) {
      this.modalService.openModal({
        component: ConfirmationModalComponent,
        data: {
          title: 'Close Adjustment Type',
          content: 'Are you sure you want to cancel your actions and close it?',
        } as Message,
        success: () => {
          this.closeAllModals();
        },
      });
    } else {
      this.closeAllModals();
    }
  }

  getSelectedTargetedFinancial(): TbaParameter {
    return this.parameters.find(parameter => parameter.tbaParameterId === this.adjustmentType.tbaParameter.tbaParameterId);
  }

  private create(): void {
    this._adjustmentTypesService.save(this.adjustmentType).subscribe(() => {
      this.closeAllModals();
      this.success();
    });
  }

  private edit(): void {
    this._adjustmentTypesService.edit(this.data.adjustmentTypeId, this.adjustmentType).subscribe(() => {
      this.closeAllModals();
      this.success();
    });
  }

  private getAdjustmentType() {
    this._adjustmentTypesService.show(this.data.adjustmentTypeId).subscribe(({ data }) => {
      this.adjustmentType = data;
    });
  }

  private getAllowedParams(): void {
    this._tbasService.getRelatedParameters(this.data.tbaId).subscribe((res) => {
      this.parameters = res.result.parameters;
    });
  }
}
